
const defaultValuesByFlavor = {
  element: {
    fnDefaultValue: () => ({ currentStatus: { indicators: [] } }),
  },

  elementType: {
    fnDefaultValue: () => ({
      currentStatus: { indicators: [] },
      templateStatus: { indicators: [] },
      seriesId: null,
      seriesConfig: {
        uniqueIdConf: { uniqueId: null, seriesId: null },
        serialNumberConf: { serialNumber: null, seriesId: null },
      },
      nameOfNewItem: 'pn+name',
    }),
  },

  asset: {
    tabDataPath: 'flavors.asset',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  assetType: {
    tabDataPath: 'flavors.asset',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  device: {
    tabDataPath: 'flavors.device',
    fnDefaultValue: () => {
      return {
        isAlive: true,
        deviceInterfaces: [],
      };
    },
  },

  group: {
    tabDataPath: 'flavors.group',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  livestock: {
    tabDataPath: 'flavors.livestock',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  livestockType: {
    tabDataPath: 'flavors.livestock',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  location: {
    tabDataPath: 'flavors.location',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  locationType: {
    tabDataPath: 'flavors.location',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  person: {
    tabDataPath: 'flavors.person',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  personType: {
    tabDataPath: 'flavors.person',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  process: {
    tabDataPath: 'flavors.process',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  processType: {
    tabDataPath: 'flavors.process',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  vehicle: {
    tabDataPath: 'flavors.vehicle',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  wipPart: {
    tabDataPath: 'flavors.wipPart',
    fnDefaultValue: () => ({ isAlive: true }),
  },

  itemInCustody: {
    tabDataPath: 'flavors.itemInCustody',
    fnDefaultValue: () => ({ isAlive: true }),
  },
};

const getDefaultValue = (flavorsArray = []) => {
  let defaultValue = {};
  flavorsArray.map(flavor => {
    if (defaultValuesByFlavor[flavor] && defaultValuesByFlavor[flavor].fnDefaultValue) {
      if (defaultValuesByFlavor[flavor].tabDataPath) {
        defaultValue = _.merge(
          defaultValue,
          _.set(defaultValue, defaultValuesByFlavor[flavor].tabDataPath, defaultValuesByFlavor[flavor].fnDefaultValue())
        );
      } else {
        defaultValue = _.merge(defaultValue, defaultValuesByFlavor[flavor].fnDefaultValue());
      }
    }
  });

  return defaultValue;
};

export default getDefaultValue;
